import React from 'react';
import { useAuthStore } from '../features/authentication/stores/authStore';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import logoutIcon from '../assets/logout.svg';

const UserStatusBadge: React.FC = () => {
  const { isCROUser, isCustomerSuccessUser, isAdminUser, isViewerUser, username } = useAuthStore();

  const getUserStatus = () => {
    if (isCROUser()) {
      return { label: 'CRO', color: '#e74c3c', bgColor: '#fdf2f2', role: 'cro' };
    } else if (isCustomerSuccessUser()) {
      return { label: 'Customer Success', color: '#f39c12', bgColor: '#fef9e7', role: 'customer_success' };
    } else if (isAdminUser()) {
      return { label: 'Admin', color: '#e74c3c', bgColor: '#fdf2f2', role: 'admin' };
    } else if (isViewerUser()) {
      return { label: 'Viewer', color: '#f39c12', bgColor: '#fef9e7', role: 'viewer' };
    } else {
      return { label: 'User', color: '#27ae60', bgColor: '#f0f9f4', role: 'user' };
    }
  };

  const status = getUserStatus();

  return (
    <span
      data-testid="user-status-badge"
      data-user-role={status.role}
      data-user-email={username}
      style={{
        ...styles.badge,
        color: status.color,
        backgroundColor: status.bgColor,
        border: `1px solid ${status.color}20`,
      }}
    >
      {status.label}
    </span>
  );
};

const Header: React.FC<{ presetId?: number }> = ({ presetId }) => {
  const { username } = useAuthStore();
  const location = useLocation();

  return (
    <header style={styles.header}>
      <img src={require('../assets/logo3.png')} alt="logo" style={{ height: '3.9vh', marginRight: '2.4vh' }} />

      <h1 style={styles.title}>Pricing Calculator</h1>
      <div style={{ width: '3.2vh' }} />

      <nav style={styles.nav}>
        <Link
          to="/"
          style={{
            ...styles.link,
            ...(location.pathname === '/' ? styles.activeLink : {}),
          }}
        >
          Main Page
        </Link>
        <Link
          to="/preset-list"
          style={{
            ...styles.link,
            ...(location.pathname === '/preset-list' ? styles.activeLink : {}),
          }}
        >
          Preset List
        </Link>
      </nav>
      <div style={{ flex: 1 }} />
      <div style={styles.welcomeContainer}>
        <div style={styles.welcome}>Welcome, {username}</div>
        <UserStatusBadge />
      </div>
      <div style={{ width: '3.2vh' }} />
      <LogoutButton />
    </header>
  );
};

const LogoutButton: React.FC = () => {
  const { logout } = useAuthStore();

  const handleLogout = () => {
    logout();
  };

  return (
    <button
      onClick={handleLogout}
      style={styles.button}
      onMouseEnter={e => (e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor)}
      onMouseLeave={e => (e.currentTarget.style.backgroundColor = styles.button.backgroundColor)}
    >
      <img src={logoutIcon} alt="logout" style={{ width: '2.4vh', height: '2.4vh' }} />
    </button>
  );
};

const styles = {
  header: {
    minHeight: '6.4vh',
    padding: '0vh 3.2vh',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0vh 0.4vh 1.2vh -0.4vh rgba(16, 29, 59, 0.1)',
    zIndex: 1000,
  },
  route: {
    fontSize: '1.6vh',
    marginLeft: '2vh',
  },
  title: {
    margin: 0,
    fontSize: '1.8vh',
    fontWeight: '700',
    color: '#101D3B',
  },
  welcomeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.2vh',
  },
  welcome: {
    fontSize: '1.6vh',
    fontWeight: '700',
    color: '#101D3B',
  },
  badge: {
    fontSize: '1.2vh',
    fontWeight: '600',
    padding: '0.4vh 0.8vh',
    borderRadius: '1.2vh',
    textTransform: 'uppercase' as 'uppercase',
    letterSpacing: '0.05vh',
  },
  button: {
    backgroundColor: '#ffffff',
    color: '#2d3436',
    border: 'none',
    borderRadius: '0.5vh',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  buttonHover: {
    backgroundColor: '#ced4da',
    color: '#2d3436',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    color: '#101D3B',
    height: '100%',
    width: '40vh',
  },
  link: {
    height: '100%',
    marginRight: '1.2vh',
    textDecoration: 'none',
    color: '#101D3B',
    fontSize: '1.6vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.3s ease',
    padding: '0vh 1.6vh',
    fontWeight: '700',
  },
  activeLink: {
    borderBottom: '0.4vh solid #00AB9B',
    borderTop: '0.4vh solid #fff',
    borderLeft: 'none',
    borderRight: 'none',
    color: '#00AB9B',
    boxSizing: 'border-box' as 'border-box',
  },
};

export default Header;
